/**
 * Клиентская отправка WebEvent: POST /api/track/event, fire-and-forget.
 * Сервер сам берёт visitorId из cookie и проверяет имя события по allowlist
 * (lib/analytics/web-event.ts). Ошибки глотаются: это аналитика.
 */
import type { ClientWebEventName, WebEventMeta, WebEventSurface } from './web-event';

export type SendWebEventInput = {
  name: ClientWebEventName;
  subject?: string;
  surface?: WebEventSurface;
  /** Только блоговые поля: сервер принимает их по закрытому списку. */
  meta?: Pick<WebEventMeta, 'viewId' | 'scrollPct' | 'activeSec' | 'target'>;
  /**
   * Событие из кабинета родителя: сервер берёт семью из сессии родителя
   * (#209, PR3b). Без сессии событие не пишется.
   */
  cabinet?: boolean;
};

export function sendWebEvent(input: SendWebEventInput): void {
  if (typeof window === 'undefined') return;
  try {
    fetch('/api/track/event', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...input, path: window.location.pathname }),
      keepalive: true,
      credentials: 'same-origin',
    }).catch(() => {});
  } catch {
    // молча
  }
}
